module.exports = __webpack_public_path__ + "static/media/torre-expositor.7379f207.svg";